import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";
import ProductVisual from "./ProductVisual";

function Main() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const categories = [productData[0], productData[2], productData[8]];

  return (
    <main className="main">
      <section className="home-hero">
        <div className="home-hero__copy">
          <p className="eyebrow">UIGHTPARCEL / EVERYDAY SERIES 01</p>
          <h1>Useful clothes.<br />Room to move.</h1>
          <p className="home-hero__intro">
            A considered edit of relaxed layers, practical separates and simple accessories for repeat wear.
          </p>
          <Link onClick={toTop} to="/shop" className="pill-link">Explore the collection</Link>
        </div>
        <div className="home-hero__art" aria-label="Original Uightparcel abstract artwork" role="img">
          <span className="hero-disc" />
          <span className="hero-grid" />
          <strong>01</strong>
          <small>MAKE SPACE<br />FOR EVERY DAY</small>
        </div>
      </section>

      <section className="home-note">
        <p className="eyebrow">THE EDIT</p>
        <p>Designed as a flexible wardrobe: familiar forms, comfortable proportions and colour that is easy to combine.</p>
      </section>

      <section className="home-categories" aria-labelledby="category-title">
        <div className="section-heading">
          <p className="eyebrow">SHOP BY MOOD</p>
          <h2 id="category-title">Three ways into the collection.</h2>
        </div>
        <div className="category-grid">
          {categories.map((product, index) => (
            <Link key={product.id} to={`/shopDetails/${product.id}`} onClick={toTop} className="editorial-card">
              <ProductVisual product={product} />
              <div className="editorial-card__caption">
                <span>0{index + 1}</span>
                <h3>{product.category}</h3>
                <p>{product.description[0]}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="home-manifesto">
        <p className="eyebrow">OUR APPROACH</p>
        <h2>Fewer claims.<br />Clearer choices.</h2>
        <p>
          We describe products in plain language and publish only material we create or are authorised to use. Current catalogue visuals are original AI-generated representations based on the listed product details.
        </p>
      </section>

      <section className="home-products" aria-labelledby="new-title">
        <div className="section-heading section-heading--row">
          <div>
            <p className="eyebrow">CURRENT EDIT</p>
            <h2 id="new-title">Everyday Series 01</h2>
          </div>
          <Link onClick={toTop} to="/shop" className="text-arrow">View all <span aria-hidden="true">↗</span></Link>
        </div>
        <div className="product-row">
          {productData.slice(0, 8).map((product) => (
            <Link onClick={toTop} to={`/shopDetails/${product.id}`} key={product.id} className="home-product-card">
              <ProductVisual product={product} />
              <h3>{product.name}</h3>
              <p>${product.price}</p>
            </Link>
          ))}
        </div>
      </section>

      <section className="home-journal">
        <div className="journal-art" aria-hidden="true"><span>U</span><span>P</span></div>
        <div className="journal-copy">
          <p className="eyebrow">A SMALL WARDROBE STUDY</p>
          <h2>Start with what works.</h2>
          <p>Build around the pieces you reach for most: a useful jacket, a balanced trouser, one strong colour and a reliable bag.</p>
          <Link onClick={toTop} to="/about" className="pill-link pill-link--dark">Read our approach</Link>
        </div>
      </section>
    </main>
  );
}

export default Main;
